// ============================================
// INFRASTRUCTURE - Ecommerce Repository
// ============================================

import { axiosClient } from './axios-client';
import type { PedidosResponse, PedidosFiltros } from '../../domain/dtos';

export const ecommerceRepository = {
  /**
   * Obtener pedidos del ecommerce con filtros
   * GET /ecommerce/admin/pedidos
   */
  async obtenerPedidos(filtros?: PedidosFiltros): Promise<PedidosResponse> {
    const params = new URLSearchParams();
    
    if (filtros?.cliente && filtros.cliente.length >= 3) {
      params.append('cliente', filtros.cliente);
    }
    if (filtros?.estado) {
      params.append('estado', filtros.estado);
    }
    if (filtros?.desde) {
      params.append('desde', filtros.desde);
    }
    if (filtros?.hasta) {
      params.append('hasta', filtros.hasta);
    }
    if (filtros?.page !== undefined) {
      params.append('page', filtros.page.toString());
    }

    const queryString = params.toString();
    const url = queryString ? `/ecommerce/admin/pedidos?${queryString}` : '/ecommerce/admin/pedidos';
    
    const { data } = await axiosClient.get<PedidosResponse>(url);
    return data;
  },

  /**
   * Cancelar un pedido
   * PATCH /ecommerce/admin/pedidos/{pedidoId}/cancelar
   */
  async cancelarPedido(pedidoId: number): Promise<void> {
    await axiosClient.patch(`/ecommerce/admin/pedidos/${pedidoId}/cancelar`);
  },

  /**
   * Completar un pedido
   * PATCH /ecommerce/admin/pedidos/{pedidoId}/completar
   */
  async completarPedido(pedidoId: number): Promise<void> {
    await axiosClient.patch(`/ecommerce/admin/pedidos/${pedidoId}/completar`);
  },
};
